module.exports = __webpack_public_path__ + "img/tema-1-13.80a0c818.png";